export const setIsAppUpdateScheduledToStorage = (isAppUpdateScheduled: boolean): void => {
  localStorage.setItem('isAppUpdateScheduled', isAppUpdateScheduled.toString());
};
